import {
  BulkActionProps,
  BulkDeleteButton,
  Button,
  FormWithRedirect,
  Identifier,
  SaveButton,
  SelectInput,
  useListContext,
  useNotify,
  useRefresh,
} from "react-admin";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Select } from "@material-ui/core";
import { client, clientNoJson } from "../dataProvider";
import { useToggler } from "../shared/hooks/useToggler";
import { useState } from "react";
import { generateError, getFileNameFromContentDisposition } from "../shared/utils";
import SendIcon from '@material-ui/icons/Send';
import CodeIcon from '@material-ui/icons/Code';
import IconCancel from "@material-ui/icons/Cancel";
import { GiPayMoney } from "react-icons/gi";
import { BiReset } from "react-icons/bi";

const CalculateExtraCostButton = ({ values }: { values?: Identifier[] }) => {
  const { value, setFalse, setTrue } = useToggler();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState<boolean>(false);
  const { selectedIds, refetch } = useListContext();


  const handleSubmit = (e: any) => {
    setLoading(true);

    client(`invoices/generate_extra_cost_invoices`, {
      method: "POST",
      data: {
        ids: values,
        ...e
      },
      responseType: "json",
    }).then((response) => {
      if (response.errors) {
        window.alert(response.errors);
      }
      else {
        notify("Fatture aggiornate");
      }
      setFalse();
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
      });

    refetch();

  };

  return (
    <>
      <Button
        size="small"
        color="primary"
        label="Calcola costi su fatture"
        onClick={setTrue}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <><GiPayMoney /></>}
      </Button>
      <Dialog
        open={value}
        onClick={(e) => e.stopPropagation()}
        fullWidth
        maxWidth="sm"
      >
        <FormWithRedirect
          resource="xxx"
          save={handleSubmit}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <DialogTitle>Calcola costi extra su fatture</DialogTitle>
                <SelectInput source="types" choices={[
                  { id: 'fixed', name: 'Fissi' },
                ]}
                  fullWidth
                  label="Tipi di costi extra"
                             defaultValue={"fixed"}
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={setFalse}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};


const ResetExtraCostButton = ({ values }: { values?: Identifier[] }) => {
  const { value, setFalse, setTrue } = useToggler();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState<boolean>(false);
  const { selectedIds, refetch } = useListContext();


  const handleSubmit = (e: any) => {
    setLoading(true);

    client(`invoices/reset_extra_cost_invoices`, {
      method: "POST",
      data: {
        ids: values,
        ...e
      },
      responseType: "json",
    }).then((response) => {
      if (response.errors) {
        window.alert(response.errors);
      }
      else {
        notify("Fatture aggiornate");
      }
      setFalse();
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
      });

    refetch();

  };

  return (
    <>
      <Button
        size="small"
        color="primary"
        label="Resetta flag su fatture"
        onClick={setTrue}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <><BiReset /></>}
      </Button>
      <Dialog
        open={value}
        onClick={(e) => e.stopPropagation()}
        fullWidth
        maxWidth="sm"
      >
        <FormWithRedirect
          resource="xxx"
          save={handleSubmit}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <DialogTitle>Resetta flag costi extra su fatture</DialogTitle>
                <SelectInput source="types" choices={[
                  { id: 'fixed', name: 'Fissi' },
                ]}
                  fullWidth
                  label="Tipi di costi extra"
                             defaultValue={"fixed"}
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={setFalse}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const SendInvoiceButton = ({ values }: { values?: Identifier[] }) => {
  const { value, setFalse, setTrue } = useToggler();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState<boolean>(false);


  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    let res = null;

    try {
      res = await clientNoJson(`api/invoices/send_invoice_emails/`, {
        method: "POST",
        data: { ids: values },
        responseType: "arraybuffer",
      });
    } catch (err) {
      notify("ra.message.error", "error");
      setLoading(false);
      return;
    }
    setLoading(false);
    notify("Fatture inviate", "success");
    try {
      refresh();
    }
    catch (e) {

    }

  };

  return (
    <>
      <Button
        size="small"
        color="primary"
        label="Invia fatture"
        onClick={handleSubmit}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <><SendIcon /></>}
      </Button>
    </>
  );
};

const GenerateXMLInvoiceButton = ({ values }: { values?: Identifier[] }) => {
  const { value, setFalse, setTrue } = useToggler();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState<boolean>(false);


  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    let res = null;

    try {
      res = await clientNoJson(`api/invoices/generate_xml_invoices/`, {
        method: "POST",
        data: { ids: values },
        responseType: "arraybuffer",
      });
    } catch (err) {
        try{
            var enc = new TextDecoder("utf-8")
            notify(JSON.parse(enc.decode(err.response.data))["detail"], "error");
        }
        catch (e) {
            console.log(e)
            notify("ra.message.error", "error");
        }

      setLoading(false);
      return;
    }
    setLoading(false);
    const data = res.data; // or res.blob() if using blob responses

    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: res.headers["content-type"],
      })
    );
    const actualFileName = getFileNameFromContentDisposition(
      res.headers["content-disposition"]
    );

    // uses the download attribute on a temporary anchor to trigger the browser
    // download behavior. if you need wider compatibility, you can replace this
    // part with a library such as filesaver.js
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", actualFileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);
    try {
      refresh();
    }
    catch (e) {

    }

  };

  return (
    <>
      <Button
        size="small"
        color="primary"
        label="Crea xml fatture"
        onClick={handleSubmit}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <><CodeIcon /></>}
      </Button>
    </>
  );
};


export const BulkActions = (props: BulkActionProps) => {
  const { selectedIds } = props;

  return (
    <>
      <GenerateXMLInvoiceButton values={selectedIds} />
      <SendInvoiceButton values={selectedIds} />
      <CalculateExtraCostButton values={selectedIds} />
      <ResetExtraCostButton values={selectedIds} />
      <BulkDeleteButton undoable={false} {...props} />
    </>
  );
};
